import {css} from '@emotion/react';
import styled from '@emotion/styled';

import {TabRow} from '@/modules/hotels/components/List/components/TabRow/TabRow';

type Props = {
  isMapVisible: boolean;
};

export const Container = styled.div<Props>(
  ({theme, isMapVisible}) => css`
    position: fixed;
    inset: 0;
    z-index: 3;
    display: flex;
    flex-direction: column;
    pointer-events: none;
    touch-action: none;
    background: ${isMapVisible
      ? '#f2efe9' // default google map background
      : 'none'};

    ${TabRow} {
      background-color: ${theme.colors.backgroundPrimary};
      width: 100%;
      align-items: stretch;
    }

    > * {
      pointer-events: all;
    }
  `
);
